import type { SVGProps } from 'react';
const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect
            x={31.5}
            y={31.5}
            width={31}
            height={31}
            rx={15.5}
            transform="rotate(180 31.5 31.5)"
            fill="#1D1D1B"
        />
        <path
            d="M14.2205 19.7754L17.7798 16.0004L14.2205 12.2254"
            stroke="white"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x={31.5}
            y={31.5}
            width={31}
            height={31}
            rx={15.5}
            transform="rotate(180 31.5 31.5)"
            stroke="#1D1D1B"
        />
    </svg>
);
export default ArrowRight;
